import axios from 'axios'
import store from '../store'
import router from '../router'
/* import { useToast } from 'vue-toastification'

const toast = useToast() */

const sieviApi = axios.create({
    baseURL: `${process.env.VUE_APP_API_URL}`,
    withCredentials: true,
    /* params: {
        key: 'AIzaSyAkmzoFHPAASW6q_DLy4PhRIvjnxq6U1YQ',
    } */
})

/* tutorApi.interceptors.request.use( ( config ) => {
    return config
}), function (error) {
    return Promise.reject(error);
} */

sieviApi.interceptors.response.use( undefined, async error => {
    store.dispatch('general/toggleLoading')
    const idToken = localStorage.getItem('idToken')

    if (error.response.status === 401 && error.response.statusText === "Unauthorized" && idToken) {
        store.commit("general/setToast", 
        { 
            severity: 'error', 
            summary: 'ALERTA', 
            detail: 'SESIÓN CADUCADA'
        })
        router.push({ name: 'auth.login' })
        await store.dispatch('auth/logout')
    }
    store.dispatch('general/toggleLoading')
    return Promise.reject(error)
})


export default sieviApi